import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_DOUBLE_OPTIN_ENABLED_NEW_USER = createFcmConfig('double_optin_enabled_new_user', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
